<template>
    <modal :show.sync=show modalClasses="medium-sized-modal" :hide-footer="true">
        <h3 slot="header" class="mb-0 font-weight-500">Set Status</h3>
        
        <b-form>
            <b-row>
                <b-col cols="12">
                    <b-form-group label="Sub Status">
                        <el-select v-model="formData.status_id" placeholder="Sub Status">
                            <el-option
                            v-for="status in customer_sub_status_list"
                            :key="status.status_id"
                            :label="status.status"
                            :value="status.status_id">
                            </el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                <b-col md="6" sm="12" class="mx-auto text-center mt-4 pt-2">
                    <b-button type="submit" class="w-100" variant="primary" @click.prevent="updateCustomerStatus">Confirm</b-button>
                </b-col>
            </b-row>
        </b-form>
    </modal>
</template>
<script>
import Modal from "@/components/Modal"
import { Select, Option } from 'element-ui'
import {
    notifyFunctionMixin,
    helperFunctionMixin,
    axios,
    services,
    getHeader
} from '@/assets/js/httpImports.js'
import mainEventBus from '@/assets/js/mainEventBus'

export default {
    props:{
        show_set_customers_status: Boolean,
        customer_sub_status_list: Array,
        multiple_selection: Array
    },
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        Modal,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    computed: {
        show: {
            get() {
                return this.show_set_customers_status;
            },
            set(newVal) {
                this.$emit('update:show_set_customers_status', newVal);
            },
        },
    },
    watch: {
        multiple_selection(newVal) {
            if (newVal) {
                this.formData.customer_ids = newVal.map(customer => customer.customer_id)
            }
        },
    },
    data() {
        return {
            formData: {
                customer_ids: [],
                status_id: '',
            }
        }
    },
    methods: {
        updateCustomerStatus() {
            axios.post(services.customer + 'customers/assign_status_bulk', this.formData, { headers: getHeader() })
            .then(res => {
                this.notifySuccess('<b>Customers Status - <br>Successfully Updated.')
                mainEventBus.$emit('refresh-table-data')
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        tegnok() {
            console.log(this.formData)
        }
    }
}
</script>